import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useNotificationStore = defineStore('notifications', () => {
  // State
  const notifications = ref([])
  const notificationId = ref(0)

  // Getters
  const activeNotifications = computed(() => notifications.value)
  const notificationCount = computed(() => notifications.value.length)

  // Actions
  const addNotification = (notification) => {
    const id = ++notificationId.value
    const newNotification = {
      id,
      type: notification.type || 'info',
      title: notification.title || '',
      message: notification.message || '',
      duration: notification.duration || 5000,
      autoClose: notification.autoClose !== false,
      dismissible: notification.dismissible !== false,
      persistent: notification.persistent || false,
      timestamp: new Date()
    }
    
    notifications.value.push(newNotification)
    return id
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearAllNotifications = () => {
    notifications.value = []
  }

  const clearNotificationsByType = (type) => {
    notifications.value = notifications.value.filter(n => n.type !== type)
  }

  // Convenience methods
  const success = (message, options = {}) => {
    return addNotification({
      type: 'success',
      message,
      ...options
    })
  }

  const error = (message, options = {}) => {
    return addNotification({
      type: 'error',
      message,
      persistent: true, // Errors should be persistent by default
      ...options
    })
  }

  const warning = (message, options = {}) => {
    return addNotification({
      type: 'warning',
      message,
      ...options
    })
  }

  const info = (message, options = {}) => {
    return addNotification({
      type: 'info',
      message,
      ...options
    })
  }

  return {
    // State
    notifications,
    
    // Getters
    activeNotifications,
    notificationCount,
    
    // Actions
    addNotification,
    removeNotification,
    clearAllNotifications,
    clearNotificationsByType,
    
    // Convenience methods
    success,
    error,
    warning,
    info
  }
}) 